import { render, staticRenderFns } from "./CustomerTrackingNote.vue?vue&type=template&id=954d4bde&scoped=true&"
import script from "./CustomerTrackingNote.vue?vue&type=script&lang=js&"
export * from "./CustomerTrackingNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954d4bde",
  null
  
)

export default component.exports